const SET_ITEM_ID = 'SET_ITEM_ID'
const SET_CONTENT_TYPE = 'SET_CONTENT_TYPE'
const SET_ITEM_TYPE = 'SET_ITEM_TYPE'
const SET_SHUFFLE = 'SET_SHUFFLE'
const SET_QUESTION = 'SET_QUESTION'
const SET_ANSWERS = 'SET_ANSWERS'
const SET_ACTIVE_EDIT = 'SET_ACTIVE_EDIT'
const IS_SAVING = 'IS_SAVING'
const SAVING_SUCCESS = 'SAVING_SUCCESS'
const SAVING_ERROR = 'SAVING_ERROR'
const OPEN_MODAL = 'OPEN_MODAL'
const CLOSE_MODAL = 'CLOSE_MODAL'
const CREATE_NEW_ITEM = 'CREATE_NEW_ITEM'
const CC_SET_ANSWER = 'CC_SET_ANSWER'
const CC_SET_STARTING_LETTER = 'CC_SET_STARTING_LETTER'
const CC_ADD_NODE_TAG = 'CC_ADD_NODE_TAG'
const CC_DELETE_NODE_TAG = 'CC_DELETE_NODE_TAG'
const CC_FETCHING_NODES = 'CC_FETCHING_NODES'
const CC_FETCHING_NODES_SUCCESS = 'CC_FETCHING_NODES_SUCCESS'
const CC_FETCHING_NODES_ERROR = 'CC_FETCHING_NODES_ERROR'


export function setItemId (id) {
  return {
    type: SET_ITEM_ID,
    id
  }
}

export function setContentType (contentType) {
  return {
    type: SET_CONTENT_TYPE,
    contentType
  }
}

export function setItemType (itemType) {
  return {
    type: SET_ITEM_TYPE,
    itemType
  }
}

export function setShuffle (shuffleQ) {
  return {
    type: SET_SHUFFLE,
    shuffleQ
  }
}

export function setQuestion (question) {
  return {
    type: SET_QUESTION,
    question
  }
}

export function setAnswers (answers) {
  return {
    type: SET_ANSWERS,
    answers
  }
}

export function setActiveEdit (activeEdit) {
  return { 
    type: SET_ACTIVE_EDIT,
    activeEdit
  }
}

export function isSavingSetTrue () {
  return {
    type: IS_SAVING
  }
}

export function savingSuccess (lastSaved) {
  return {
    type: SAVING_SUCCESS,
    lastSaved
  }
}

export function savingError (error) {
  return {
    type: SAVING_ERROR,
    error
  }
}

export function openModal (message) {
  return {
    type: OPEN_MODAL,
    message,
  }
}

export function closeModal () {
  return {
    type: CLOSE_MODAL,
  }
}

export function createNewItem () {
  return {
    type: CREATE_NEW_ITEM,
  }
}

export function setAnswer (index, answer) {
  return {
    type: CC_SET_ANSWER,
    index,
    answer,
  }
}

export function setStartingLetter (letter) {
  return {
    type: CC_SET_STARTING_LETTER,
    letter,
  }
}

export function addNodeTag (nodeId) {
  return {
    type: CC_ADD_NODE_TAG,
    nodeId,
  }
}

export function deleteNodeTag (nodeId) {
  return {
    type: CC_DELETE_NODE_TAG,
    nodeId,
  }
}

export function fetchingNodes () {
  return {
    type: CC_FETCHING_NODES,
  }
}

export function fetchingNodesSuccess (nodes) {
  return {
    type: CC_FETCHING_NODES_SUCCESS,
    nodes,
  }
}

export function fetchingNodesError (error) {
  return {
    type: CC_FETCHING_NODES_ERROR,
    error,
  }
}



const initialState = {
  itemId: '',
  contentType: 'Item',
  itemType: 'Multiple Choice',
  shuffle: false,
  question: 'this is where the question goes',
  answers: [
    {
      correct: true,
      answer: 'Add a correct choice here',
      feedback: 'Explain why this is right',
    },
    {
      correct: false,
      answer: 'Add an incorrect choice here',
      feedback: 'explain why this is also wrong',
    },
    {
      correct: false,
      answer: 'Add an incorrect choice here',
      feedback: 'explain why this is also wrong',
    },
    {
      correct: false,
      answer: 'Add an incorrect choice here',
      feedback: 'explain why this is also wrong',
    }
  ],
  activeEdit: {
    type: '',
    index: 0
  },
  isFetching: false,
  isSaving: false,
  error: '',
  lastSaved: '',
  noChanges: false,
  modalOpen: false,
  modalMessage: '',
  startingLetter: 'a',
  nodeTags: null,
  nodes: null,
}
export function createContent (state = initialState, action) {
  switch (action.type) {
    case SET_ITEM_ID :
      return {
        ...state,
        itemId: action.id,
        noChanges: false,
      }
    case SET_CONTENT_TYPE :
      return {
        ...state,
        contentType: action.contentType,
        noChanges: false,
      }
    case SET_ITEM_TYPE :
      return {
        ...state,
        itemType: action.itemType,
        noChanges: false
      }
    case SET_SHUFFLE :
      let startingLetter
      action.shuffleQ ? startingLetter = '' : startingLetter = 'a'
      return {
        ...state,
        shuffle: action.shuffleQ,
        noChanges: false,
        startingLetter,
      }
    case SET_QUESTION :
      return {
        ...state,
        question: action.question,
        noChanges: false
      }
    case SET_ANSWERS :
      return {
        ...state,
        answers: action.answers,
        noChanges: false,       
      }
    case SET_ACTIVE_EDIT :
      return {
        ...state,
        activeEdit: action.activeEdit,
        noChanges: false,
      }
    case IS_SAVING :
      return {
        ...state,
        isSaving: true,
        error: '',
      }
    case SAVING_SUCCESS :
      return {
        ...state,
        isSaving: false,
        error: '',
        lastSaved: action.lastSaved,
        noChanges: true
      }
    case SAVING_ERROR :
      return {
        ...state,
        isSaving: false,
        error: action.error,
      }
    case OPEN_MODAL : 
      return {
        ...state,
        modalOpen: true,
        modalMessage: action.message,
      }
    case CLOSE_MODAL :
      return {
        ...state,
        modalOpen: false,
        modalMessage: '',
      }
    case CREATE_NEW_ITEM : 
      return {
        ...initialState
      }
    case CC_SET_ANSWER :
      let newAnswers = state.answers.slice(0)
      newAnswers.splice(action.index, 1, action.answer)
      return {
        ...state,
        answers: newAnswers,
        noChanges: false,
      }
    case CC_SET_STARTING_LETTER :
      return {
        ...state,
        startingLetter: action.letter,
      }
    case CC_ADD_NODE_TAG :
      let newNodeTags = {
        [action.nodeId]: true,
      }
      if (state.nodeTags) {
        newNodeTags = {
          ...state.nodeTags,
          [action.nodeId]: true,
        }
      }
      return {
        ...state,
        nodeTags: newNodeTags,
      }
    case CC_DELETE_NODE_TAG :
      return {
        ...state,
        nodeTags: {
          ...state.nodeTags,
          [action.nodeId]: false,
        }
      }
    case CC_FETCHING_NODES :
      return {
        ...state,
        isFetching: true,
      }
    case CC_FETCHING_NODES_SUCCESS : 
      return {
        ...state,
        isFetching: false,
        nodes: action.nodes,
      }
    case CC_FETCHING_NODES_ERROR : 
      return {
        ...state,
        isFetching: false,
        error: action.error,
      }
    default :
      return state
  }
}




/*

sampleItemState = {
  itemId: 'idstring',
  contentType: 'Item',
  itemType: 'Multiple Choice',
  shuffle: false,
  question: '<p>Hello world</p>',
  answers: [
    {
      correct: false,
      answer: '<p>yes</p>',
      feedback: '<p>it is not yes</p>' 
    },
    {
      correct: true,
      answer: '<p>no</p>',
      feedback: '<p>it is no</p>'
    },
    {
      correct: false,
      answer: '<p>no indeed</p>',
      feedback: '<p>it is not no indeed, no indeed</p>',
    }
  ],
  activeEdit: 'feedback1',
  isFetching: false
}
 

Actions:

Fetch data to edit
save data
Add answer
Remove answer
Change one of the input fields

*/


// WEBPACK FOOTER //
// ./src/redux/modules/createContent.js